// src/firebase.js
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyBMkWX4hOsFM-tMtec0VvTQ56nsAvSVMSg",
  authDomain: "snooker-hut.firebaseapp.com",
  databaseURL: "https://snooker-hut-default-rtdb.firebaseio.com",
  projectId: "snooker-hut",
  storageBucket: "snooker-hut.firebasestorage.app",
  messagingSenderId: "718738022760",
  appId: "1:718738022760:web:4d3b164b9982517c6af6dd"
};

export const app = initializeApp(firebaseConfig);
